<script>
	import AddressAutoComplete from "./AddressAutoComplete.svelte";
	import Checkbox from "./Checkbox.svelte";

	export let idPrefix = "a" + uuid4().substring(0, 3);
	export let googlePlaceJson = null;
	export let formattedAddress = null;
	export let premise = null;
	export let subpremise = null;
	export let street = null;
	export let suburb = null;
	export let state = null;
	export let postcode = null;
	export let country = null;
	export let lat = null;
	export let lng = null;
	export let placeId = null;
	export let url = null;
	export let disabled;
	export let required;
</script>

<AddressAutoComplete
	{idPrefix}
	bind:googlePlaceJson
	bind:formattedAddress
	bind:premise
	bind:subpremise
	bind:street
	bind:suburb
	bind:state
	bind:postcode
	bind:country
	bind:lat
	bind:lng
	bind:placeId
	bind:url
	{disabled}
	{required}
></AddressAutoComplete>
